import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GodRaysBackground from "@/components/GodRaysBackground";
import Landing from "@/pages/Landing";

function App() {
  return (
    <div className="App min-h-screen w-full">
      <GodRaysBackground />
      <div className="relative" style={{ zIndex: 1 }}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
